import { CanActivateFn, RedirectCommand, Router } from "@angular/router"
import { GuardResult } from "@angular/router/router_module.d-Bx9ArA6K"
import { inject, PLATFORM_ID } from "@angular/core"
import { ApiHttpService } from "../services/api.service"
import { isPlatformServer } from "@angular/common"
import { catchError, of } from "rxjs"
import { env } from "../../env"
import { SubscriptionType } from "@home-shark/types"

export const authGuard: (subType: SubscriptionType) => CanActivateFn =
    (subType: SubscriptionType) => (route, state) => {
        const router = inject(Router)
        const api = inject(ApiHttpService)
        const platformId = inject(PLATFORM_ID)

        return new Promise<boolean>((resolve, reject) => {
            if (isPlatformServer(platformId)) return resolve(false)
            api.get<boolean>("/users/subscription-type")
                .pipe(catchError((err) => of(false)))
                .subscribe((value: SubscriptionType | boolean) => {
                    console.log("Subscription type", value)
                    // *No Sub* < standard < pro < agent
                    if (!subType || subType === "standard") resolve(!!value)
                    else if (subType === "pro") {
                        resolve(value === "agent" || value === "pro")
                    } else if (subType === "agent") {
                        resolve(value === "agent")
                    }
                })
        }).then((res: boolean): GuardResult => {
            if (res === true) return true

            const loginPath = router.parseUrl(
                env.staging ? "/staging-login-wall" : "/?login=true"
            )
            return new RedirectCommand(loginPath, { skipLocationChange: false })
            // const loginPath = router.parseUrl("/login")
            //   return new RedirectCommand(loginPath, { skipLocationChange: true })
        })
    }
